export default __webpack_public_path__ + "static/media/thai_iced_tea.35ac2c62.JPG";